const MEASURE_OVERVIEW_COMPACT_KEY = "MeasureOverviewCompactFilter";

export function getSessionStorageMeasureOverviewCompactFilter(): boolean {
  const value = sessionStorage.getItem(MEASURE_OVERVIEW_COMPACT_KEY);

  return value === "true";
}

export function setSessionStorageMeasureOverviewCompactFilter(
  compact: boolean,
): void {
  sessionStorage.setItem(MEASURE_OVERVIEW_COMPACT_KEY, String(compact));
}

const MEASURE_OVERVIEW_SHOW_CLOSED_KEY = "MeasureOverviewShowClosedFilter";

export function getSessionStorageMeasureOverviewShowClosedFilter(): boolean {
  const value = sessionStorage.getItem(MEASURE_OVERVIEW_SHOW_CLOSED_KEY);

  return value === "true";
}

export function setSessionStorageMeasureOverviewShowClosedFilter(
  showClosed: boolean,
) {
  sessionStorage.setItem(MEASURE_OVERVIEW_SHOW_CLOSED_KEY, String(showClosed));
}
